
export class QuestionRange {
  start: number; // inclusive
  end: number; // exclusive

  constructor(start: number, end: number) {
    this.start = start;
    this.end = end;
  }
}